<template>
  <div>
    <van-row style="height: 38px; line-height: 35px; background: #000000">
      <van-col
        span="2"
        style="line-height: 35px"
        @click="$router.push({ name: 'CapitalAccount', query: { activeTab: '2' } })"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 5px"
          color="#ffffff"
          size="27px"
        />
      </van-col>
    <van-col span="22" style="margin-left: -5px;">
      <div class="btnBorder"  v-if ="selectedAccount.direction_capital == 2" style="display: flex; height: 25px; border-radius: 4px; overflow: hidden;">
        <!-- Direction 0 -->
        <div
          :class="[directionTab === '0' ? 'activeDirBtn' : '']"
          style="flex: 1; text-align: center; line-height: 25px; border-radius: 2px 0 0 2px;"
          @click="directionTab = '0'"
        >
          <span class="btnText">{{$t("app.trading.trade")}}</span>
        </div>

        <!-- Direction 1 -->
        <div
          :class="[directionTab === '1' ? 'activeDirBtn' : '']"
          style="flex: 1; text-align: center; line-height: 25px; border-radius: 0 2px 2px 0;"
          @click="directionTab = '1'"
        >
          <span class="btnText">{{$t("app.trading.tradeD")}}</span>
        </div>
      </div>
      <div class="btnBorder"  v-if ="selectedAccount.direction_capital == 1" style="display: flex; height: 25px; border-radius: 4px; overflow: hidden;">
        <!-- Direction 1 -->
        <div
          :class="[directionTab === '1' ? 'activeDirBtn' : '']"
          style="flex: 1; text-align: center; line-height: 25px; border-radius: 0 2px 2px 0;"
          @click="directionTab = '1'"
        >
          <span class="btnText">{{$t("app.trading.tradeD")}}</span>
        </div>
      </div>
      <div class="btnBorder"  v-if ="selectedAccount.direction_capital == 0" style="display: flex; height: 25px; border-radius: 4px; overflow: hidden;">
        <!-- Direction 0 -->
        <div
          :class="[directionTab === '0' ? 'activeDirBtn' : '']"
          style="flex: 1; text-align: center; line-height: 25px; border-radius: 2px 0 0 2px;"
          @click="directionTab = '0'"
        >
          <span class="btnText">{{$t("app.trading.trade")}}</span>
        </div>
      </div>
    </van-col>

    </van-row>
    
    <van-row style="height: 38px; line-height: 35px; background: #000000">
        <van-col span="6" >
        <div
          class="btnBorder"
          style="display: flex; height: 100%; border-radius: 4px; overflow: hidden;"
        >
          <div
            :class="['van-col', buySellTab === 'buy' ? 'activeBtn' : '']"
            style="flex: 1; text-align: center; line-height: 25px; border-radius: 0 2px 2px 0;"
            @click="buySellTab = 'buy'"
          >
            <span class="btnText">{{$t("app.trading.buy")}}</span>
          </div>

          <!-- 买入 -->
          <div
            :class="['van-col', buySellTab === 'sell' ? 'activeBtn' : '']"
            style="flex: 1; text-align: center; line-height: 25px; border-radius: 2px 0 0 2px;"
            @click="buySellTab = 'sell'"
          >
            <span class="btnText">{{$t("app.trading.sell")}}</span>
          </div>
        </div>
      </van-col>
      <van-col span="14" id="capitalAccountStyle">
        <div>
          <van-field
            readonly
            clickable
            :value="selectedAccount.name + '(' + selectedAccount.order + ')'"
            @click="showPicker = true"
            style="
              height: 30px;
              background: #000000;
              color: #ffffff;
              line-height: 30px;
              margin-top: 4px;
              padding: 0;
              text-align: right;
            "
          />
        </div>
      </van-col>
      <van-col span="2">
        <van-icon
          name="arrow-down"
          style="padding-top: 11px"
          color="#ffffff"
          size="16px"
          @click="showPicker = true"
        />
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="capitalAccountsPickerList"
        @cancel="showPicker = false"
        @confirm="onAccountSelect"
        :cancel-button-text="$t('app.common.cancel')"
        :confirm-button-text="$t('app.common.confirm')"
        style="font-size: 14px"
      />
    </van-popup>
    <div class="mainSection">
      <div class="tradingSection">
        <van-row class="shareDesign">
          <van-col span="6" class="shareNames">
            <span class="shareName">{{ topData.name }}</span>
          </van-col>
          <van-col span="6">
            <span class="shareCode">{{
              selectedShare ? selectedShare.substring(2) : "--"
            }}</span>
          </van-col>
          <van-col span="6">
            <span
              class="currentPrice"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ updown }}</span
            >
          </van-col>
          <van-col span="6" style="text-align: right">
            <span
              class="increasePrecent"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{
                isNaN(topData.increasePercent)
                  ? "--"
                  : parseFloat(topData.increasePercent).toFixed(3)
              }}%</span
            >
          </van-col>
        </van-row>

        <van-row style="padding-top: 10px">
          <!-- ======================== serach stock ================ -->
          <van-col span="14">
            <van-row style="border: 1px solid #387fff">
              <van-col span="20">
                <div id="searchStyle">
                  <van-field
                    v-model="search"
                    placeholder=""
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 32px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                  /></div
              ></van-col>
              <van-col span="4" style="border-left: 1px solid #387fff">
                <div>
                  <!-- <router-link > to="/trading_search_stock" -->
                  <van-icon
                    name="search"
                    size="27px"
                    color="#ffffff"
                    @click="$router.push({ name: 'TradingSearchStock' })"
                  />
                  <!-- </router-link> -->
                </div>
              </van-col>
            </van-row>
            <!-- ====================== start set price ============== -->
            <van-row style="padding-top: 4px">
              <van-col span="6">
                <van-button type="info" size="small" @click="onMarketPrice">{{
                  priceButtonLabel
                }}</van-button>
              </van-col>
              <van-col span="4" class="minusSignCol">
                <van-button
                  type="info"
                  class="minusSign"
                  @click="onPriceControlButton('down')"
                  >-</van-button
                >
              </van-col>
              <van-col span="10" class="limitValue">
                <div id="searchStyle">
                  <van-field
                    v-model="price"
                    @blur="settingPriceAmount"
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 30px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                    :readonly="priceButtonLabel === marketPriceLabel"
                  />
                </div>
              </van-col>
              <van-col span="4" class="plusSignCol">
                <van-button
                  type="info"
                  class="plusSign"
                  @click="onPriceControlButton('up')"
                  >+</van-button
                >
              </van-col>
            </van-row>

            <!-- ============================= start max and min value ================== -->
            <!-- 
            <van-row style="padding-top: 5px">
              <van-col span="11" style="text-align: left">
                <div class="lossAmt" @click="setLimitPrice(topData.dropPrice)">
                  跌停:<span>{{ topData.dropPrice }}</span>
                </div>
              </van-col>
              <van-col span="2"></van-col>
              <van-col span="11" style="text-align: right">
                <div style="padding: 1px">
                  <div
                    class="lossAmt"
                    @click="setLimitPrice(topData.hardenPrice)"
                  >
                    涨停: <span>{{ topData.hardenPrice }}</span>
                  </div>
                </div>
              </van-col>
            </van-row> -->

            <!-- ======================== start number of stocks ============================ -->

            <van-row style="padding-top: 4px">
              <van-col span="4" class="minusSignCol">
                <van-button
                  type="info"
                  class="minusSign"
                  @click="onAmountControlButton('down')"
                  >-</van-button
                >
              </van-col>
              <van-col span="16" class="limitValue">
                <div id="searchStyle">
                  <van-field
                    v-model="quantity"
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 30px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                  />
                </div>
              </van-col>
              <van-col span="4" class="plusSignCol">
                <van-button
                  type="info"
                  class="plusSign"
                  @click="onAmountControlButton('up')"
                  >+</van-button
                >
              </van-col>
            </van-row>

            <!-- ===========================  start total number of shares =================== -->

            <!-- <van-row style="padding-top: 2px">
              <van-col span="13" style="text-align: left; font-size: 14px">
                <span
                  style="line-height: 30px; color: #ffffff; font-size: 13px"
                >
                  {{ buySellTab === "buy" ? "可买股数" : "可卖股数" }} :</span
                ><span style="color: #ffffff">{{ getBuyableAmount }}</span>
              </van-col>
              <van-col span="11" style="text-align: right; font-size: 14px">
                <span
                  style="line-height: 30px; color: #ffffff; font-size: 13px"
                >
                  每手股数 :</span
                ><span style="color: #ffffff">{{ hands_volume }}</span>
              </van-col>
            </van-row> -->
          </van-col>
          <!-- ==================== Start Right panel with 5 list price================================ -->
          <van-col span="10">
            <van-row style="padding: 3px 10px 12px">
              <van-col span="24" style="text-align: center"
                ><p style="color: #ffffff; margin: 0px">{{$t("app.trading.market")}}</p></van-col
              >
            </van-row>
            <!-- <van-row>
              <van-col span="24" style="text-align:center"> <span>五格行情</span> </van-col>
            </van-row> -->
            <!-- <van-row>
              <van-col span="24" style="height: 14px"> </van-col>
            </van-row> -->
            <!-- ====================== sell 5 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">卖5</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.sell5Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell5Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== sell 4 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">卖4</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.sell4Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell4Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== sell 3 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">卖3</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.sell3Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell3Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== sell 2 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">卖2</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.sell2Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell2Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== sell 1 =================== -->
            <van-row>
              <van-col span="6">
                <span class="capital" style="align-items: unset; padding-left: 10px;">{{$t("app.trading.sell1")}}</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red; padding-top: 2px">{{
                  isNaN(topData.sell1Price)
                    ? "--"
                    : parseFloat(topData.sell1Price).toFixed(3)
                }}</span>
              </van-col>
              <van-col span="10">
                <span
                  class="capital"
                  style="align-items: flex-end; padding-top: 2px"
                  >{{ topData.sell1Num }}</span
                >
              </van-col>
            </van-row>

            <van-row style="padding: 10px 0px 5px 10px">
              <van-col span="24" style="border: 1px solid #969799"></van-col>
            </van-row>

            <!-- ====================== buy 1 =================== -->
            <van-row>
              <van-col span="6">
                <span class="capital" style="align-items: unset; padding-left: 8px;">{{$t("app.trading.buy1")}}</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red; padding-top: 2px">{{
                  isNaN(topData.buy1Price)
                    ? "--"
                    : parseFloat(topData.buy1Price).toFixed(3)
                }}</span>
              </van-col>
              <van-col span="10">
                <span
                  class="capital"
                  style="align-items: flex-end; padding-top: 2px"
                  >{{ topData.buy1Num }}</span
                >
              </van-col>
            </van-row>
            <!-- ====================== buy 2 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">买2</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.buy2Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy2Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== buy 3 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">买3</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.buy3Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy3Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== buy 4 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">买4</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.buy4Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy4Num }}</span>
              </van-col>
            </van-row> -->
            <!-- ====================== buy 5 =================== -->
            <!-- <van-row>
              <van-col span="8">
                <span class="capital">买5</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: red">{{
                  topData.buy5Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy5Num }}</span>
              </van-col>
            </van-row> -->
          </van-col>
        </van-row>

        <van-row style="padding-top: 2px">
          <van-col span="14" style="text-align: left; font-size: 14px">
            <span style="line-height: 30px; color: #ffffff;">
              {{ buySellTab === "buy" ? this.$t('app.trading.availablebuy') : this.$t('app.trading.availablesell') }} </span
            ><span style="color: #ffffff">{{ getBuyableAmount }} {{$t('app.trading.shares')}} </span>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="14">
            <!-- ======================= start quick quantity select ======================== -->

            <van-row style="padding-top: 0px">
              <van-col span="8" style="padding-right: 5px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn == 1 ? 'tradingQtyStyle' : ''"
                  @click="setTradingQty(1)"
                  >{{$t("app.trading.full")}}</van-button
                >
              </van-col>
              <van-col span="8" style="padding-right: 2px; padding-left: 2px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn == 1 / 2 ? 'tradingQtyStyle' : ''"
                  @click="setTradingQty(1 / 2)"
                  >{{$t("app.trading.half")}}</van-button
                >
              </van-col>
              <van-col span="8" style="padding-left: 5px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn == 1 / 3 ? 'tradingQtyStyle' : ''"
                  @click="setTradingQty(1 / 3)"
                  >{{$t("app.trading.1/3")}}</van-button
                >
              </van-col>
            </van-row>
          </van-col>
          <van-col span="10">
            <!-- ======================== buy and sell button===================== -->

            <van-row style="padding-top: 0px">
              <van-col span="2"> </van-col>
              <van-col span="20">
                <van-button
                  type="danger"
                  size="large"
                  style="height: 26px"
                  v-if="buySellTab === 'buy'"
                  @click="buySellOperation"
                  >{{$t("app.trading.buy_button")}}</van-button
                >
                <van-button
                  type="primary"
                  size="large"
                  style="height: 26px"
                  v-if="buySellTab === 'sell'"
                  @click="buySellOperation"
                  >{{$t("app.trading.sell_button")}}</van-button
                >
              </van-col>
              <van-col span="2"> </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>

    <!-- ====================== Below table details =================== -->

    <van-tabs
      v-model="active"
      id="detailTable"
      background="#c8c9cc"
      @click="onTabClick"
    >
      <!-- ====================== Tab 1 =================== -->
      <van-tab :title="$t('app.tradingColumns.position')" name="depot">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.name")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.position_available")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.price_cost")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.profit_loss")}}</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.market_value")}}</span>
          </van-col>
        </van-row>

        <van-row
          v-for="(item, index) in depotList"
          :key="index"
          style="height: 40px"
          @click="onDepotItem(item)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>
                {{
                  item.name.length >= 4
                    ? item.name.substr(0, 4) + "..."
                    : item.name
                }}
              </p>
              <p>{{ item.code_new }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.sellable }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>
                {{
                  bottomStockList
                    .find((o) => o.short === item.short)
                    .price.toFixed(2)
                }}
              </p>
              <p>{{ parseFloat(item.price).toFixed(2) }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: #0adc0aad">
              <p
                v-bind:class="[
                  getFloatingProfitPercentage(item) >= 0
                    ? 'redText'
                    : 'greenText',
                ]"
              >
                {{ getFloatingProfitPercentage(item) }}%
              </p>
              <p
                v-bind:class="[
                  getFloatingProfitPercentage(item) >= 0
                    ? 'redText'
                    : 'greenText',
                ]"
              >
                {{ getFloatingFullProfit(item) }}
              </p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ getCurrentTotal(item) }}</p>
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 2 =================== -->
      <van-tab :title="$t('app.tradingColumns.cancel')" name="cancel">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.name")}}</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.delegation_status")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.entrust_transaction")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.position_availablesell")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.commision_time")}}</span>
          </van-col>
        </van-row>

        <van-row
          v-for="(item, index) in cancelList"
          :key="index"
          style="height: 40px"
          @click="cancelEntrustConfirm(item)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code_new }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.status }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.deal }}</p>
              <p>{{ item.price !== "0.00" ? item.price : "--" }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.finish }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{$getDeviceTime(item.time) }}</p>
              <!-- <p>{{ item.accurate }}</p> -->
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 3 =================== -->
      <van-tab :title="$t('app.tradingColumns.entrust')" name="entrust">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.name")}}</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.delegation_status")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.entrust_transaction")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.position_availablesell")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.commision_time")}}</span>
          </van-col>
        </van-row>
        <van-row
          v-for="(item, index) in entrustLogList"
          :key="index"
          style="height: 40px"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code_new }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.status }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.deal != 0 ? item.deal.toFixed(3) : "--" }}</p>
              <p>{{ item.price != 0 ? item.price.toFixed(3) : "--" }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.finish }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ $getDeviceTime(item.time) }}</p>
              <!-- <p>{{ item.accurate }}</p> -->
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 4 =================== -->
      <van-tab :title="$t('app.tradingColumns.deal')" name="deal">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.name")}}</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.buy_sell_qty")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.price_total")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.fee")}}</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">{{$t("app.tradingColumns.commision_time")}}</span>
          </van-col>
        </van-row>
        <van-row
          v-for="(item, index) in dealLogList"
          :key="index"
          style="height: 40px"
          @click="showPopup(item.id)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code_new }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.number }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.price.toFixed(3) }}</p>
              <p>{{ item.total }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.fee }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ $getDeviceTime(item.time) }}</p>
              <!-- <p>{{ item.accurate }}</p> -->
            </div>
          </van-col>
        </van-row>
        <!-- ============================================ Deal POPup =========================================== -->
        <van-popup v-model="showDealPopup" round style="width: 90%">
          <table style="width: 100%; padding: 20px">
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_time")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ $getDeviceTime(dealData.time) }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_name")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.type }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_code")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.name }} {{ dealData.code_new }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_code")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.number }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_price")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.price }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_amt")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.total }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_commision")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.commission }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_levy")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.change }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_stamp")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.stamp }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_fee")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee1 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_delivery_fee")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee2 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_plt_fee")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee3 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.trading_activity_fee")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.transaction }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_frc")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.chj_levy }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>{{$t("app.trading.dealpop_sum")}}</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.totalplus }}</span>
              </td>
            </tr>
          </table>
          <van-row style="padding: 10px">
            <van-col span="2"></van-col>
            <van-col span="20">
              <van-button
                type="danger"
                size="normal"
                style="width: 100%; height: 34px"
                @click="closePopup()"
                >{{$t("app.common.cancel")}}</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
          </van-row>
        </van-popup>
      </van-tab>
    </van-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup v-model="showTradeChannelPopup" closeable style="width: 85%">
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >{{$t("app.trading.undestand")}}
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  name: "Trading",
  data() {
    return {
      buySellTab: "buy",
      active: "depot",
      search: "",
      price: 0,
      quantity: 0,
      sellableQty: 0,
      selectedShare: "",
      selectedShare1: "",
      hands_volume: "--",
      price_change: 0.001,
      timerRef: null,
      topData: {
        name: "--",
        increase: "--",
        price: "--",
        increasePercent: "--",
        dropPrice: "--",
        hardenPrice: "--",
        sell5Price: "--",
        sell4Price: "--",
        sell3Price: "--",
        sell2Price: "--",
        sell1Price: "--",
        sell5Num: "--",
        sell4Num: "--",
        sell3Num: "--",
        sell2Num: "--",
        sell1Num: "--",
        buy1Price: "--",
        buy2Price: "--",
        buy3Price: "--",
        buy4Price: "--",
        buy5Price: "--",
        buy1Num: "--",
        buy2Num: "--",
        buy3Num: "--",
        buy4Num: "--",
        buy5Num: "--",
      },
      selectedAccount: { name: "--", order: "--" },
      marketPriceBuyLabel: this.$t('app.trading.market_buy'),
      marketPriceSellLabel: this.$t('app.trading.market_sell'),
      limitPriceLabel: this.$t('app.trading.limitprice'),
      marketPriceLabel: this.$t('app.trading.marketprice'),
      priceButtonLabel: "",
      capitalAccountList: [],
      showPicker: false,
      capitalAccountsPickerList: [],
      depotList: [],
      cancelList: [],
      entrustLogList: [],
      dealLogList: [],
      dealData: {},
      bottomStockList: [],
      timmerFrequncy: 2000,
      timmerRef: null,
      showDealPopup: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      quntityBtn: null,
      stockData: [],
      directionTab : 0,
      direction: 0,
      stockFee:'',
    };
  },
  watch: {
    quantity: function (val) {
      if (val < 0) {
        this.quantity = 0;
        return;
      }
    },
    price: function (val) {
      if (this.priceButtonLabel === this.limitPriceLabel) {
        this.buyableAmountCalculation();
      }
    },
search(val) {
    if (!val) {
      // optional: clear results if empty
      this.selectedShare = "";
      return;
    }
    this.query_stocks(val);
  },
    buySellTab: function () {
      if (this.priceButtonLabel === this.marketPriceLabel) {
        this.price =
          this.buySellTab === "buy"
            ? this.marketPriceBuyLabel
            : this.marketPriceSellLabel;
      }
      //set qty input 0 when tab is changed
      this.quantity = 0;
      this.quntityBtn = null;
    },
    directionTab(val) {
      if (val === '1') {
        this.$router.push({ name: 'TradingDirection', params: { direction: 1 } });
      }
    }
  },
  computed: {
    getBuyableAmount() {
      if (this.buySellTab === "buy") {
        return this.buyableAmountCalculation();
      } else {
        //when showing sell tab, check selected share depot in the list
        //and show sellabel qty
        if (this.selectedShare) {
          let shareItem = this.depotList.find(
            (o) => o.short === this.selectedShare
          );
          if (shareItem) {
            this.sellableQty = shareItem.sellable;
          } else {
            this.sellableQty = 0;
          }
        }
        return this.sellableQty;
      }
    },
    updown() {
      let val = (this.topData.price - this.topData.yesterdayClosePrice).toFixed(
        2
      );
      return isNaN(val) ? "--" : val;
    },
  },
  methods: {
    settingPriceAmount() {
      if ((this.price * 1000) % (this.price_change * 1000) > 0) {
        Dialog.alert({
          message: this.$t('app.trading.warn1') + this.price_change,
          confirmButtonText: this.$t('app.common.confirm'),
        }).then(() => {
          // on close
        });
        return;
      }
    },
    query_stocks(query) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "get_stocks",
            words: query,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length >= 1) {
              that.selectedShare = res.data.data[0].short;
              that.hands_volume = res.data.data[0].hands_volume;
              that.price_change = res.data.data[0].price_change;
              that.selectedShare1 = res.data.data[0].code;
              that.loadMarketData(true);
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(that.$t(res.data.msg));
          } else if (res.data.code === -1) {
            that.$logout(that.$t(res.data.msg));
          }
        });
    },
    cancelEntrustConfirm(item) {
      let that = this;
      Dialog.confirm({
        title: this.$t('app.tradingColumns.cancel'),
        message: this.$t('app.trading.warn7'),
        cancelButtonText: this.$t('app.common.cancel'),
        confirmButtonText: this.$t('app.common.confirm'),
      })
        .then(() => {
          that.cancelEntrust(item);
        })
        .catch(() => {});
    },
    cancelEntrust(item) {
      let that = this;
      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "cancel_entrust",
          token: sessionStorage.getItem("token"),
          cid: that.selectedAccount.cid,
          order: item.id,
          direction: 0,
        },
      })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.success(that.$t(res.data.msg));
            that.onTabClick();
          } else if (res.data.code == 0) {
            Toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(function () {
          Toast.fail();
        });
    },
    onTabClick() {
      switch (this.active) {
        case "depot":
          this.active = "depot";
          this.getDepotStock();
          break;
        case "cancel":
          this.geCancelOrders();
          break;
        case "entrust":
          this.getEntrustLog();
          break;
        case "deal":
          this.getDealLog();
          break;
        default:
          break;
      }
    },
    getDepotStock() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
            direction: 0,
          },
        })
        .then(function (res) {
          that.depotList = [];
          if (res.data.code == 1) {
            that.depotList = res.data.data;
            // console.log("Depot response:", that.depotList.price);
            that.loadMarketData();
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    geCancelOrders() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
            direction: 0,
          },
        })
        .then(function (res) {
          that.cancelList = [];
          if (res.data.code == 1) {
            that.cancelList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    getEntrustLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
            direction: 0,
          },
        })
        .then(function (res) {
          that.entrustLogList = [];
          if (res.data.code == 1) {
            that.entrustLogList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    getDealLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
            direction: 0,
          },
        })
        .then(function (res) {
          that.dealLogList = [];
          if (res.data.code == 1) {
            that.dealLogList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    showPopup(dealId) {
      // this.showDealPopup = true;
      let that = this;
      Toast.loading({
        forbidClick: true,
      });
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: sessionStorage.getItem("token"),
            deal_id: dealId,
            direction: 0,
          },
        })
        .then(function (res) {
          Toast.clear();
          if (res.data.code == 1) {
            that.dealData = res.data.data[0];
            that.showDealPopup = true;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    closePopup() {
      this.showDealPopup = false;
    },
    setTradingQty(ratio) {
      if (this.buySellTab === "buy") {
        let qty = parseFloat(this.buyableAmountCalculation() * ratio).toFixed(
          0
        );
        // qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      } else {
        let qty = parseFloat(this.sellableQty * ratio).toFixed(0);
        // qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      }
      this.quntityBtn = ratio;
    },
    buyableAmountCalculation() {
      if (this.selectedAccount == null || this.selectedShare === "") return 0;
      let use = parseFloat(this.selectedAccount.use);
      let totalFee = 0;
      let price =
        this.priceButtonLabel === this.marketPriceLabel
          ? parseFloat(this.topData.sell1Price).toFixed(3)
          : parseFloat(this.price).toFixed(3);
      let stockqty = use/price;
      let change = 0;
			let commission = this.stockFee.buy * stockqty;
      if (commission < 0.99) commission = 0.99;
      let stockCode=0;
      let extraFee1 = 0;
      let extraFee2 = (this.stockFee.extra_fee2)*stockqty;
      let extraFee3 = (this.stockFee.extra_fee3)*stockqty;
      if(extraFee3 < 1) extraFee3 = 1;
      // const exp = String(this.stockFee.platform_exp || '').trim();
      // const m = exp.match(/=\s*([\d.]+)/);
      // if (m) {
      //   extraFee3 = Number(m[1]); // override to 8 or 15
      // }
      let stamp = 0;
      let chj_levy = 0;
      let transaction = 0;

      // totalFee = Number(this.stockFee.stamp) + Number(change) + Number(commission) + this.stockFee.extra_fee1 
      // + this.stockFee.extra_fee2 + Number(this.stockFee.extra_fee3) + Number(this.stockFee.chj_levy);

      totalFee = Number(stamp) + Number(change) + Number(commission) + Number(extraFee1)
      + Number(extraFee2) + Number(extraFee3) + Number(chj_levy) + Number(transaction);

      let qty = price > 0 ? Math.floor((use - Number(totalFee)) / price) : 0;
      qty = qty > 0 ? qty : 0;
      return isNaN(qty) ? "--" : qty;
    },
    onAmountControlButton(direction) {
      let currentQty = parseInt(this.quantity) || 0;
      if (direction === "up") {
         this.quantity = currentQty + 1;
      }
      if (direction === "down") {
        if (currentQty >= 1) {
          this.quantity = currentQty - 1;
        } else {
            this.quantity = 0;
        }
      }
    },
    /**
     * method to controll price +,- buttons
     * 1. check if limit price set, if not change to limit price
     * 2. if direction up, increase price by 0.05
     * 3. if direction down, decriment price by 0.05
     */
    onPriceControlButton(direction) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
        // this.price = parseFloat(this.topData.price).toFixed(3);
        this.price = Number(this.topData.price) || 0; // keep it a number
        this.price = Number(this.price.toFixed(3));
        return;
      }
      if(this.price_change > 0){
        let price = Number(this.price) || 0;
        let price_change = Number(this.price_change) || 0;
        if (direction === "up") {
          let upAmt = (price * 1000) % (price_change * 1000);
          let plusAmt = price - upAmt / 1000;
          price = plusAmt + price_change;
        }
        if (direction === "down") {
          let downAmt = (price * 1000) % (price_change * 1000);
          let minusAmt = price - downAmt / 1000;
          price = minusAmt - price_change;
        }

        this.price = price.toFixed(3);
      } else{
        this.price = 0;
      }
      
    },
    setLimitPrice(price) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
      }
      this.price = price.toFixed(3);
    },
    onMarketPrice() {
      if (this.priceButtonLabel === this.marketPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
        this.price = (
          this.buySellTab === "buy"
            ? this.topData.sell1Price
            : this.topData.buy1Price
        ); //parseFloat(this.topData.price).toFixed(3);
      } else {
        this.priceButtonLabel = this.marketPriceLabel;
        this.price =
          this.buySellTab === "buy"
            ? this.marketPriceBuyLabel
            : this.marketPriceSellLabel;
      }
    },
    /**
     * load capital account info
     * 1.get capital data
     * 2.set first account as selected account
     * 3.load depot stock
     */
    getCapitalAccounts() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
            direction: 0,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.capitalAccountList = res.data.data;
            if (that.capitalAccountList.length == 0) {
              Dialog.confirm({
                message: that.$t('app.trading.warn8'),
                cancelButtonText: that.$t('app.common.cancel'),
                confirmButtonText: that.$t('app.common.confirm'),
              })
                .then(() => {
                  that.$router.push({ name: "CreateCapitalAccounts" });
                })
                .catch(() => {
                  that.$router.go(-1);
                });
            } else {
              if (that.$store.state.selectedCid) {
                that.selectedAccount = that.capitalAccountList.find(
                  (o) => o.cid == that.$store.state.selectedCid
                );
              } else {
                that.selectedAccount = that.capitalAccountList[0];
              }
              that.$store.commit("setLastSelectedAccount", that.selectedAccount);
              //generate list for picker
              that.capitalAccountsPickerList = [];
              that.capitalAccountList.forEach(function (element, index) {
                let item = {
                  text:
                    element.name +
                    "(" +
                    element.order +
                    ")" + that.$t('app.trading.balance')+
                    element.use,
                  value: index,
                  direction_capital : element.direction_capital,
                };
                if(item.direction_capital == 0 || item.direction_capital == 2){
                  that.capitalAccountsPickerList.push(item);
                }
              });
              that.getDepotStock();
            }
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          } else if (res.data.code == -1) {
            that.$logout(that.$t(res.data.msg));
          }
        });
    },
    /**
     * load market data from datasource
     * 1.get all market data from datasource
     * 2.set top data part
     * 3.set bottom data parts
     */
    loadMarketData(changeInputPrice = false) {
      let that = this;

      let stockList = [];
      if (that.selectedShare) {
        stockList.push(that.selectedShare);
      }
      that.depotList.forEach((item) => {
        stockList.push(item.short);
      });

      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "shuhai_price",
            code: stockList.toString(),
            withcode: 0,
          },
        })
        .then((res) => {
          this.stockData = res.data.data;

          if (that.selectedShare) {
            that.topData = that.getStockObject(that.selectedShare);
            if (
              changeInputPrice &&
              that.priceButtonLabel === that.limitPriceLabel
            ) {
              that.price = that.topData.price.toFixed(3);
            }
          }
          that.bottomStockList = [];
          stockList.forEach((item) => {
            that.bottomStockList.push(that.getStockObject(item));
          });
        });

      // let url =
      //   "https://sqt.gtimg.cn/utf8/q=" +
      //   that.selectedShare +
      //   "," +
      //   stockList.toString();
      // $.ajax({
      //   url: url,
      //   type: "GET",
      //   dataType: "script",
      //   cache: true,
      //   success: function () {
      //     if (that.selectedShare) {
      //       that.topData = that.getStockObject(that.selectedShare);
      //       if (
      //         changeInputPrice &&
      //         that.priceButtonLabel === that.limitPriceLabel
      //       ) {
      //         that.price = that.topData.price;
      //       }
      //     }
      //     that.bottomStockList = [];
      //     stockList.forEach((item) => {
      //       that.bottomStockList.push(that.getStockObject(item));
      //     });
      //   },
      // });
    },
    getCurrentTotal(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return (marketData.price * share.number).toFixed(2);
    },
    getFloatingFullProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return (marketData.price * share.number - share.costtotal).toFixed(2);
      // return parseFloat((this.getFloatingProfit(share) * share.number)-share.costtotal).toFixed(
      //   2
      // );
    },
    getFloatingProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return marketData.price - share.price;
    },
    getFloatingProfitPercentage(share) {
      if (share.price > 0) {
        return parseFloat(
          (this.getFloatingProfit(share) / share.price) * 100
        ).toFixed(2);
      } else {
        return "--";
      }
    },
    getStockObject(stock) {
      let elements = this.stockData.find(
        (o) => o.Symbol === stock.toUpperCase()
      );
      let item = {};
      item.name = elements["Name"]; // 股票名称
      item.code = elements["Symbol"]; // 不带字幕的股票代码，603045
      item.short = stock;
      item.price = elements["NewPrice"]; //elements[3]; // 当前价格
      item.yesterdayClosePrice = elements["LastClose"]; // 昨收
      item.todayOpenPrice = elements["Open"]; // 今开

      item.buy1Price = elements["BP1"]; // 买1价格
      item.buy1Num = elements["BV1"]; // 买1数量（手）
      // item.buy2Price = elements[11]; // 买2价格
      // item.buy2Num = elements[12]; // 买2数量（手）
      // item.buy3Price = elements[13]; // 买3价格
      // item.buy3Num = elements[14]; // 买3数量（手）
      // item.buy4Price = elements[15]; // 买4价格
      // item.buy4Num = elements[16]; // 买4数量（手）
      // item.buy5Price = elements[17]; // 买5价格
      // item.buy5Num = elements[18]; // 买5数量（手）

      item.sell1Price = elements["SP1"]; // 卖1价格
      item.sell1Num = elements["SV1"]; // 卖1数量（手）
      // item.sell2Price = elements[21]; // 卖2价格
      // item.sell2Num = elements[22]; // 卖2数量（手）
      // item.sell3Price = elements[23]; // 卖3价格
      // item.sell3Num = elements[24]; // 卖3数量（手）
      // item.sell4Price = elements[25]; // 卖4价格
      // item.sell4Num = elements[26]; // 卖4数量（手）
      // item.sell5Price = elements[27]; // 卖5价格
      // item.sell5Num = elements[28]; // 卖5数量（手）

      item.increase = elements["PriceChangeRatio"]; // 涨、跌额
      item.increasePercent = elements["PriceChangeRatio"]; // 涨、跌幅
      // item.maxPrice = elements[33]; // 最高价
      // item.minPrice = elements[34]; // 最低价

      item.num = elements["Volume"]; // 成交量(手)
      // item.totalAccount = elements[37]; // 成交额(万)
      // item.turnoverRate = elements[38]; // 换手率
      // item.priceToEarnings = elements[39]; // 市盈率

      // item.swing = elements[43]; // 振幅
      // item.stockMarketsFell = elements[44]; // 流通市值(亿)
      // item.aggregatealueListedStock = elements[45]; // 总市值(亿)
      // item.price2BookRatio = elements[46]; // 市净率
      // item.hardenPrice = elements[47]; // 涨停价
      // item.dropPrice = elements[48]; // 跌停价
      // item.volumeRatio = elements[49]; // 量比
      // item.appointment = elements[50]; // 尾差
      // item.average = elements[51]; // 均价
      return item;
    },
    onAccountSelect(item) {
      this.selectedAccount = this.capitalAccountList[item.value];
      this.$store.commit("setSelectedCid", this.selectedAccount.cid);
      this.$store.commit("setLastSelectedAccount", this.selectedAccount);
      this.showPicker = false;
      this.active = "depot";
      this.getDepotStock();
    },
    buySellOperation() {
      let that = this;

      if (that.search === "") {
        Dialog.alert({
          message: this.$t('app.trading.warn3'),
          confirmButtonText: this.$t('app.common.confirm'),
        }).then(() => {
          // on close
        });
        return;
      }
      if (that.price === "") {
        Dialog.alert({
          message: this.$t('app.trading.warn2'),
          confirmButtonText: this.$t('app.common.confirm'),
        }).then(() => {
          // on close
        });
        return;
      }

      if ((this.price * 1000) % (this.price_change * 1000) > 0) {
        Dialog.alert({
          message: this.$t('app.trading.warn1') + this.price_change,
          confirmButtonText: this.$t('app.common.confirm'),
        }).then(() => {
          // on close
        });
        return;
      }

      if (parseInt(that.quantity) == 0) {
        Dialog.alert({
          message: this.$t('app.trading.warn4'),
          confirmButtonText: this.$t('app.common.confirm'),
        }).then(() => {
          // on close
        });
        return;
      }

      let message =
        this.buySellTab === "buy"
          ? this.$t('app.trading.warn5')
          : this.$t('app.trading.warn6');

      Dialog.confirm({
        title: this.$t('app.trading.confirm'),
        message: message,
        cancelButtonText: this.$t('app.common.cancel'),
        confirmButtonText: this.$t('app.common.confirm'),
      })
        .then(() => {
          that.buySellApi();
        })
        .catch(() => {});
    },
    buySellApi() {
      let that = this;
      var nozzle = this.buySellTab === "buy" ? "buy_stock" : "sell_stock";
      var cid = this.selectedAccount.cid;
      var code = this.selectedShare1;
      var number = this.quantity;
      var price =
        this.priceButtonLabel === this.marketPriceLabel
          ? this.topData.price
          : this.price;
      var mold = this.priceButtonLabel === this.marketPriceLabel ? 2 : 1;

      Toast.loading({
        forbidClick: true,
      });

      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: nozzle,
          token: sessionStorage.getItem("token"),
          cid: cid,
          code: code,
          price: price,
          number: number,
          mold: mold,
          direction: 0,
        },
      })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.success(that.$t(res.data.msg));
            // that.active = "depot";
            that.onTabClick();
          } else if (res.data.code == 2) {
            that.getTradeChannel();
          } else if (res.data.code == 0) {
            Toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(function () {
          Toast.fail();
        });
    },

    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      Toast.loading();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.clear();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            Toast.clear();
            // that.$toast.fail(res.data.msg);
          }
        });
    },
    getStockFee() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stockfee",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
           that.stockFee = res.data;
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: that.$t(res.data.msg),
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        });
    },
    onDepotItem(item) {
      this.selectedShare = item.short;
      this.selectedShare1 = item.code;
      this.search = this.selectedShare.slice(2);
      this.sellableQty = item.sellable;
      this.loadMarketData(true);
      this.quantity = 0;
    },
  },
  mounted: function () {
    const direction = parseInt(this.$route.params.direction);
    if (this.$route.name === 'Trading') {
      this.directionTab = '0';
    } else if (this.$route.name === 'TradingDirection') {
      this.directionTab = '1';
    }
    this.priceButtonLabel = this.marketPriceLabel;
    this.selectedShare = this.$store.state.searchSelectedShare; //this.$route.params.code? this.$route.params.code: this.$store.state.searchSelectedShare;
    this.selectedShare1 = this.$store.state.searchSelectedShare1;
    // console.log(this.selectedShare1);
    this.buySellTab = this.$route.params.mode ? this.$route.params.mode : "buy";
    this.price =
      this.buySellTab === "buy"
        ? this.marketPriceBuyLabel
        : this.marketPriceSellLabel;
    if (this.selectedShare) {
      this.search = this.selectedShare.slice(2);
    }

    this.getStockFee();
    this.getCapitalAccounts();
    this.loadMarketData();
    this.timerRef = setInterval(() => {
      this.loadMarketData();
      this.onTabClick();
    }, this.timmerFrequncy);
  },
  destroyed: function () {
    clearInterval(this.timerRef);
  },
};
</script>

<style scoped>
.mainSection {
  padding: 0px 10px;
  background: #272a31;
  padding-bottom: 15px;
}
.btnBorder {
  text-align: center;
  height: 26px;
  line-height: 26px;
  margin-top: 5px;
  border: 1px solid #3889fa;
  border-radius: 4px;
}

.btnText {
  color: #ffffff;
  font-size: 14px;
}

#capitalAccountStyle {
  text-align: right;
  color: #ffffff;
}
.capital {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 14px;
}

.text_style {
  font-size: 11px;
  font-weight: bold;
}

.capital p {
  margin: 0;
  font-size: 13px;
  /* font-weight: bold; */
}

.activeBtn {
  background: #3889fa;
}
.activeDirBtn {
  background: #3889fa;
}

.shareDesign {
  text-align: center;
  padding-top: 10px;
  line-height: 25px;
  background: #000000;
  margin-left: -10px;
  margin-right: -10px;
}

.shareName {
  margin-left: 10px;
  color: #ffffff;
  font-size: 14px;
}

.shareNames {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
}

.shareCode {
  color: #ffffff;
}

.increasePrecent {
  margin-right: 10px;
}

.minusSignCol {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  border-right: 0;
  background: #000000;
  text-align: center;
}

.minusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #ffffff;
  padding: unset;
}

.limitValue {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  text-align: center;
  border-right: 0;
}

.plusSignCol {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  background: #000000;
  text-align: center;
}
.plusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #ffffff;
  padding: unset;
}

.lossAmt {
  border: 1px solid #3889fa;
  padding: 1px 4px;
  border-radius: 8px;
  color: #ffffff;
  font-size: 13px;
  width: max-content;
}

.warehouse {
  width: 100%;
  background: #757070;
  border: #757070;
  height: 26px;
}

.redText {
  color: #ff2c27;
}
.greenText {
  color: #8bc34a;
}

.dealPopupRow td {
  padding: 5px;
}

.dealPopupRow td span {
  font-size: 13px;
}

.tradingQtyStyle {
  background-color: #3889fa;
}
</style>

<style>
#detailTable .van-tabs__wrap {
  height: 30px !important;
}

#detailTable .van-tab {
  background: #dcdee0;
  color: #3889fa;
}

#detailTable .van-tab--active {
  background: #3889fa !important;
  color: #ffffff;
}

#detailTable .van-tabs__line {
  display: none;
}

#searchStyle .van-field__control {
  color: #ffffff !important;
  text-align: center;
  font-size: 14px;
}

#capitalAccountStyle .van-field__control {
  color: #ffffff !important;
  text-align: right;
  font-size: 14px;
}

#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Trading.vue